import { CircularProgress, Tooltip } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { FaUser } from 'react-icons/fa';
import { LuPhone } from 'react-icons/lu';
import { IoMdMail } from 'react-icons/io';
import Requests from 'src/network/accounts';
import { C2CProps, ContactInfo, Vendor } from '../../types';
import copyTextToClipboard from '../../utils';

const ConsultancyPopup = function ConsultancyPopup(props: C2CProps) {
  const {
    consultancyInfo,
    isVirtualRecruiter,
    openVrTab,
  } = props;

  const accountsUrl = process.env.REACT_APP_AUTH_DOMAIN;

  const [copiedEmail, setCopiedEmail] = useState<boolean>(false);
  const [copiedPhone, setCopiedPhone] = useState<boolean>(false);
  const [vendorDetails, setVendorDetails] = useState<Vendor>();
  const [vendorConsultantInfo, setVendorConsultantInfo] = useState<ContactInfo>();
  const [vendorDetailsLoading, setVendorDetailsLoading] = useState(true);

  const getConsultancyDetails = async () => {
    try {
      setVendorDetailsLoading(true);
      const consultancyContactPersonId = consultancyInfo?.consultancyContactId;
      const consultancyId = consultancyInfo?.consultancyId;
      if (!consultancyId) {
        return;
      }
      const res = await Requests.getInstance().getConsultancyById(consultancyId);
      const vendor = res.data;
      const contactPerson = vendor.contactInfo.find(
        (item) => item.id?.toString() === consultancyContactPersonId,
      );
      setVendorDetails(vendor);
      setVendorConsultantInfo(contactPerson);
    } catch (e) {
      console.info('error occured while fetching consultancyById', e);
    } finally {
      setVendorDetailsLoading(false);
    }
  };

  const copyEmail = (text: string) => {
    copyTextToClipboard(text);
    setCopiedEmail(true);
    setTimeout(() => {
      setCopiedEmail(false);
    }, 1000);
  };

  const copyPhone = (text: string) => {
    copyTextToClipboard(text);
    setCopiedPhone(true);
    setTimeout(() => {
      setCopiedPhone(false);
    }, 500);
  };

  useEffect(() => {
    getConsultancyDetails();
  }, [consultancyInfo]);

  if (vendorDetailsLoading) {
    return (
      <div className="bg-white p-10 flex gap-8 justify-center items-center flex-col">
        <CircularProgress />
      </div>
    );
  }

  return (
    <form className="bg-white p-10 flex gap-8 justify-center items-center flex-col">
      <div className="font-bold">Employer Details</div>
      {
        vendorDetailsLoading
          ? (
            <div>
              <CircularProgress />
            </div>
          )
          : (
            <div className="flex flex-col gap-2">
              <div className="w-[400px] flex-shrink-0 relative">
                <div className="text-base font-bold truncate">
                  <a href={`${accountsUrl}/vendors?view=${vendorDetails?.uuId}`} target="_blank" className="text-primary no-underline" rel="noreferrer">
                    {vendorDetails?.name}
                  </a>
                </div>
              </div>
              <div className="w-[400px] flex-shrink-0 flex items-center gap-2">
                <FaUser width={16} />
                <div className="text-md">{`${vendorConsultantInfo?.firstName || ''} ${vendorConsultantInfo?.lastName || ''}`.trim()}</div>
              </div>
              {vendorConsultantInfo?.phoneNumber && (
                isVirtualRecruiter ? (
                  <div className="flex gap-1 w-[400px] flex-shrink-0">
                    <Tooltip open={copiedPhone} title="Copied" followCursor>
                      <div
                        className="cursor-pointer hover:bg-[#ddd]"
                        onClick={() => copyPhone(vendorConsultantInfo?.phoneNumber)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            copyPhone(vendorConsultantInfo?.phoneNumber);
                          }
                        }}
                      >
                        <div
                          className="no-underline text-[#000] flex items-center gap-2"
                          onClick={() => openVrTab(vendorConsultantInfo?.emailAddress)}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                              openVrTab(vendorConsultantInfo?.emailAddress);
                            }
                          }}
                          role="button"
                          tabIndex={0}
                          aria-label="Consultancy phone number"
                        >
                          <LuPhone width={16} />
                          <div className="text-md">{vendorConsultantInfo?.phoneNumber}</div>
                        </div>

                      </div>
                    </Tooltip>
                  </div>
                ) : (
                  <div className="flex gap-1">
                    <Tooltip open={copiedPhone} title="Copied" followCursor>
                      <div
                        className="flex items-center gap-2 cursor-pointer hover:bg-[#ddd]"
                        onClick={() => copyPhone(vendorConsultantInfo?.phoneNumber)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            copyPhone(vendorConsultantInfo?.phoneNumber);
                          }
                        }}
                      >
                        <LuPhone width={14} />
                        <div className="text-md">{vendorConsultantInfo?.phoneNumber}</div>
                      </div>
                    </Tooltip>
                  </div>
                )
              )}
              <div className="w-[400px] flex-shrink-0 flex gap-1">
                <Tooltip open={copiedEmail} title="Copied" followCursor>
                  <div
                    className="flex gap-2 items-center cursor-pointer hover:bg-[#ddd]"
                    onClick={() => {
                      if (vendorConsultantInfo) {
                        copyEmail(vendorConsultantInfo?.emailAddress);
                      }
                    }}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if ((e.key === 'Enter' || e.key === ' ') && consultancyInfo) {
                        copyEmail(vendorConsultantInfo?.emailAddress
                          || consultancyInfo?.consultancyEmailAddress);
                      }
                    }}
                  >
                    <IoMdMail width={18} />
                    <div className="text-md">
                      {vendorConsultantInfo?.emailAddress
                          || consultancyInfo?.consultancyEmailAddress}
                    </div>
                  </div>
                </Tooltip>
              </div>
            </div>
          )
      }
    </form>
  );
};

ConsultancyPopup.defaultProps = {

};

ConsultancyPopup.propTypes = {

};

export default ConsultancyPopup;
